import { chakra, useMenuStyles } from '@chakra-ui/react';
import classnames from 'classnames';
import React, { useCallback, useState } from 'react';

import { useScrollLocation } from '../../hooks/useScrollLocation';
import { withChakraAs } from '../../utils/withChakraAs';

export type MenuListProps = {
  className?: string;
  children: React.ReactNode;
  ref?: React.Ref<HTMLDivElement>;
};

/**
 * Used as a wrapper for the main body of the menu.
 *
 * Should be used as the parent for all menu groups and items.
 */
export const MenuList = withChakraAs<MenuListProps, 'div'>(
  ({ className, ref, ...props }) => {
    const [menuListRef, setRef] = useState<HTMLDivElement | null>(null);
    const scrollLocation = useScrollLocation(menuListRef);

    const styles = useMenuStyles();

    const updateRef = useCallback(
      (element: HTMLDivElement | null) => {
        setRef(element);
        if (!ref) return;

        if (typeof ref === 'function') {
          return ref(element);
        } else {
          // eslint-disable-next-line no-param-reassign
          ref.current = element;
        }
      },
      [ref],
    );

    return (
      <chakra.div
        {...props}
        __css={styles.listContainer}
        // eslint-disable-next-line tailwindcss/no-custom-classname
        className={classnames('orbit-menu__list', className)}
        data-scroll-location={scrollLocation}
        ref={updateRef}
      />
    );
  },
);
